import React from "react";
import Language from "../constants/languages";

const LocalizationContext = React.createContext(Language.English);

export default LocalizationContext;
